import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  color = 'primary';
  mode = 'indeterminate';
  value = 50;
  // isLoading: Subject<boolean> = this.loaderService.isLoading;
  isLoading: boolean = false;
  constructor(private loaderService: LoaderService) {
    loaderService.LoaderEmitter.subscribe((res) => { 
      
      if (res)
        this.isLoading = true
      else
        this.isLoading = false;
    }) 
  }
}